var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarga1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.46 535.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#757575;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 81") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.19,0c5.35,2.19,11.16,2.84,16.45,5.31C180,17.61,193.91,46,187.23,74.09c-6.51,27.35-32.39,47.12-60.14,46A60.28,60.28,0,0,1,69.44,68.51C65,39.16,84.13,9.92,112.87,2.18c1.91-.52,4.09-.39,5.5-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.93,224.26c-2.85-10.8-10.35-16.68-21.2-18-18.5-2.34-35.1-9.64-50.82-19.16-21.11-12.77-39.8-28.72-58-45.18C145,120.29,113.8,115.8,87.8,136.53l-.11.09A35.13,35.13,0,0,0,75,158.94a282.15,282.15,0,0,0-1.66,65.19c2.19,25.31,4.34,49.53,6.37,73.76.92,11,1.8,22,9.35,30.87,2.2,2.59,2.06,4.45.5,7.28C73.3,365.38,57.22,394.81,41.07,424.2,28.35,447.35,15.21,470.27,3,493.69c-7.36,14.14-.61,31.45,13.7,38.51,14.93,7.37,31.46,1.45,40.16-14.34,20.54-37.28,39.5-75.4,59.42-113,6.39-12.08,13-24,19.84-36.67,1.31,2.13,2.21,3.54,3.06,5,17.12,28.87,32.42,58.71,47,88.9,9,18.6,17.27,37.55,26.2,56.18,6.64,13.84,21.28,20.09,35.34,15.7,17.82-5.57,25.63-24.16,17.59-42.2-24.5-54.94-50.88-108.92-82.21-160.35-1.74-2.86-1.5-4.72.32-7.3a35.12,35.12,0,0,0,6.83-22.54c-.87-14.6-2.21-29.17-3.46-43.74-.93-10.91-2-21.82-3.14-32.71-.17-1.52-1.16-3.31.12-4.26s2.88.38,4.14,1.33c25.73,19.4,55.52,27.33,86.9,30.64a21.4,21.4,0,0,0,14.77-4.21A22.85,22.85,0,0,0,298.93,224.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 263.86,
    y: 45.49,
    width: 184.6,
    height: 184.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.82,
    y: 144.77,
    width: 149.36,
    height: 44.3,
    rx: 22.15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarga1);
export default __webpack_public_path__ + "static/media/carga1.b0602ca3.svg";
export { ForwardRef as ReactComponent };